module.exports = __webpack_public_path__ + "media/images/emoticons/ng-3a195ed1b75fe638206f1bd6eb2a6f55.gif";